import axios from 'axios'

import { http } from 'legacy/utils/http'

export function getLoad(loadUUID) {
  return axios.get(`/api/v2/loadboard/loads/${loadUUID}`, http.getHeadersV2())
}

export function getPublicLoad(loadUUID) {
  return axios.get(`/api/v2/loadboard/public/loads/${loadUUID}`, http.getHeadersV2())
}

export function rejectLoad(id, payload) {
  return axios.post(`/api/v2/loadboard/loads/${id}/reject`, payload, http.getHeadersV2())
}
